/*
 * Wraps SATComponent.prototype.renderVals to let the product detail modal
 * (snippets/sat-overlays.liquid's hasDetail block) switch between a
 * product's alternate photos instead of only ever showing the one featured
 * image. The base `detail` binding (sat-app.js) spreads the raw product
 * record straight onto `out.detail` — that record already carries a full
 * `images` array (see snippets/sat-bootstrap.liquid), it just was never
 * exposed as a click-to-switch gallery in the modal itself.
 *
 * Tracks which photo is selected with two small state fields instead of
 * one, on purpose: `detailPhotoIdx` alone would survive across opening a
 * *different* product's detail (browsing "From The Same Department"
 * without the index resetting), silently showing that new product's photo
 * at whatever index the last one happened to be on. `detailPhotoFor`
 * records which product id the index was chosen for; a mismatch (a new
 * product opened) falls back to index 0 automatically, no explicit reset
 * needed anywhere else.
 */
(function () {
  'use strict';
  if (!window.SATComponent) { return; }

  var orig = window.SATComponent.prototype.renderVals;
  window.SATComponent.prototype.renderVals = function () {
    var out = orig.call(this);
    var self = this;
    var s = this.state;

    if (!out.detail) {
      out.detailThumbs = [];
      out.detailHasThumbs = 'none';
      return out;
    }

    var images = (out.detail.images || []).filter(Boolean);
    if (!images.length && out.detail.photo) { images = [out.detail.photo]; }

    var idx = (s.detailPhotoFor === out.detail.id && s.detailPhotoIdx > 0 && s.detailPhotoIdx < images.length)
      ? s.detailPhotoIdx : 0;

    var detailId = out.detail.id;
    out.detail = Object.assign({}, out.detail, { photo: images[idx] || out.detail.photo });
    out.detailThumbs = images.map(function (url, i) {
      var isActive = i === idx;
      return {
        url: url,
        // Ready-to-use CSS values, not a bare boolean — the template runtime
        // only does property lookups inside {{ }}, no in-template ternaries.
        borderColor: isActive ? '#F0C77A' : 'rgba(240,199,122,.25)',
        dim: isActive ? '1' : '.55',
        select: function () { self.setState({ detailPhotoIdx: i, detailPhotoFor: detailId }); }
      };
    });
    out.detailHasThumbs = images.length > 1 ? 'flex' : 'none';

    return out;
  };
})();
